import { render, staticRenderFns } from "./brand-card.vue?vue&type=template&id=f226409c&scoped=true&"
import script from "./brand-card.vue?vue&type=script&lang=js&"
export * from "./brand-card.vue?vue&type=script&lang=js&"
import style0 from "./brand-card.vue?vue&type=style&index=0&id=f226409c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f226409c",
  null
  
)

export default component.exports